import { createFileRoute } from "@tanstack/react-router"
import {
	type PersonalityAspectId,
	parsePersonalityAspectId,
} from "@/entities/personality"
import { FriendPersonalityPage } from "@/pages/friend-personality"

export const Route = createFileRoute(
	"/_authenticated/friend/$friendId/personality",
)({
	component: FriendPersonalityPageWrapper,
	validateSearch: (
		search,
	): {
		aspect?: PersonalityAspectId | undefined
		from: "profile" | "preview"
	} => ({
		aspect: parsePersonalityAspectId(search.aspect),
		from: search.from === "preview" ? "preview" : "profile",
	}),
})

function FriendPersonalityPageWrapper() {
	const { friendId } = Route.useParams()
	const { aspect, from } = Route.useSearch()

	return (
		<FriendPersonalityPage friendId={friendId} aspect={aspect} from={from} />
	)
}
